// ProjectDetails.jsx
import React from "react";
import { Card, CardContent, Typography, Divider } from "@mui/material";

export default function ProjectDetails({ fullName, startDate, businessType }) {
  // Format date to readable form
  const formattedDate = startDate
    ? new Date(startDate).toLocaleDateString(undefined, {
        year: "numeric",
        month: "long",
        day: "numeric",
      })
    : "N/A";

  return (
    
    <Card
    sx={{
      pl: 1,
      borderRadius: 3,
      border: 1,
      borderColor: "divider"
    }}
   
    >
      <CardContent>
        <Typography variant="h6" gutterBottom fontWeight="bold">
          Client Details
        </Typography>
        <Divider sx={{ mb: 2 }} />

        <Typography variant="body1" sx={{ mb: 1 }}>
          <strong>Full Name:</strong> {fullName || "N/A"}
        </Typography>
        <Typography variant="body1" sx={{ mb: 1 }}>
          <strong>Start Date:</strong> {formattedDate}
        </Typography>
        <Typography variant="body1">
          <strong>Type of Business:</strong> {businessType || "N/A"}
        </Typography>
      </CardContent>
    </Card>
  );
}
